import { render, staticRenderFns } from "./havePriced.vue?vue&type=template&id=48815ea4&scoped=true"
import script from "./havePriced.vue?vue&type=script&lang=js"
export * from "./havePriced.vue?vue&type=script&lang=js"
import style0 from "./havePriced.vue?vue&type=style&index=0&id=48815ea4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48815ea4",
  null
  
)

export default component.exports